<template src="./DocumentList.html"></template>

<script>
import { formatDate } from "../../../utils/computeds";

export default {
  name: "DocumentList",
  props: {
    documents: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    formatDate,
  },
};
</script>

<style lang="scss" src="./DocumentList.scss" scoped></style>
